(function () {
  'use strict';

  angular.module('unit.status').directive('unitStatus', unitStatus);

  unitStatus.$inject = [];

  function unitStatus() {
    var directive = {
      bindToController: true,
      controller: 'unitStatusCtrl',
      controllerAs: 'vm',
      template: require('../unit.status/unit.status.html'),
      link: link,
      restrict: 'EA',
      scope: {
        unitId: '=unitId',
        model: '=ngModel',
      },
    };
    return directive;

    function link(scope, element, attrs) {
      element.bind({
        keydown: function (e) {
          // up and down keys are blocked, because on MacOS native contol appeared
          if (
            e.which == 38 ||
            e.keyCode == 38 ||
            e.which == 40 ||
            e.keyCode == 40
          ) {
            return false;
          }
          return true;
        },
      });
    }
  }
})();
